/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Meeting Chat API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateChatMessageRequest
 */
export interface CreateChatMessageRequest {
    /**
     * The contents of this chat message.
     * @type {string}
     * @memberof CreateChatMessageRequest
     */
    message: string;
}

export function CreateChatMessageRequestFromJSON(json: any): CreateChatMessageRequest {
    return CreateChatMessageRequestFromJSONTyped(json, false);
}

export function CreateChatMessageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateChatMessageRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function CreateChatMessageRequestToJSON(value?: CreateChatMessageRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}


